export class CategoriaInscripcion {

    constructor (
        public _id ?: string,
        public nombre_es ?: string,
        public nombre_en ?: string,
        public desc_es ?: string,
        public desc_en ?: string,
        public invitado ?: string,
        public socio ?: string,
    ) { }

}



// WEBPACK FOOTER //
// ./src/app/models/categoriaInscripcion.model.ts